/** Tiny client-side event bus — thin wrapper over window events.
 *
 *  Used to fan out SSE-driven server pushes (e.g. ad_detection MISSED rows)
 *  between sibling pages without prop-drilling or React context. Components
 *  subscribe with a cleanup function:
 *
 *    import { bus, BUS } from "@/lib/eventBus";
 *    useEffect(() => bus.on(BUS.AD_DETECTION, (d) => { ... }), []);
 *
 *  Publishers fire-and-forget:
 *
 *    bus.emit(BUS.AD_DETECTION, payload);
 */
export const BUS = Object.freeze({
  AD_DETECTION: "ws:ad-detection",
  AIRPLAY: "ws:airplay",
  BOOKING_CHANGED: "ws:booking-changed",
});

export const bus = {
  emit(name, detail) {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(name, { detail }));
  },
  /** Returns an unsubscribe function — drop it straight from useEffect. */
  on(name, handler) {
    if (typeof window === "undefined") return () => {};
    const wrapped = (e) => handler(e.detail);
    window.addEventListener(name, wrapped);
    return () => window.removeEventListener(name, wrapped);
  },
};
